<template>
  <v-main class="primary">
    <transition name="fade" mode="out-in">
      <loader-component v-if="loading"></loader-component>
      <router-view v-else></router-view>
    </transition>
  </v-main>
</template>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
<script>
import { mapActions, mapMutations, mapGetters } from 'vuex'
import LoaderComponent from '../../components/LoaderComponent.vue'
import { MODULOS } from '@/perfiles'

export default {
  components: {
    LoaderComponent,
  },

  async created() {
    this.ENABLE_LOADER()
    this.setThemeByModule(MODULOS.DESARROLLO_POLICIAL)
    await Promise.all([
      this.fetchPrincipios(),
      this.fetchReactivos(),
      this.fetchFrecuenciaRespetoPrincipio(),
      this.fetchPeriodicidad(),
      this.fetchResultados(),
      this.fetchFunciones(),
      this.fetchIndicadores(),
      this.fetchFrecuenciaProductividad(),
      this.fetchActosRelevantes(),
      this.fetchProcedimiento(),
      this.fetchPromociones(),
      this.fetchTipoConvocatoria(),
      this.fetchCondecoraciones(),
      this.fetchMunicipios(),
      this.fetchEstados(),
      this.fetchEstadoCivil(),
      this.fetchTipoNacionalidad(),
      this.fetchSexo(),
      this.fetchGrupoSanguineo(),
    ])
    this.DISABLE_LOADER()
  },

  computed: {
    ...mapGetters({
      loading: 'getLoader',
    }),
  },

  methods: {
    ...mapActions('personal', ['fetchPersonal']),

    ...mapActions('respetoPrincipios', ['fetchRespetoPrincipios']),
    ...mapActions('principio', ['fetchPrincipios']),
    ...mapActions('reactivo', ['fetchReactivos']),
    ...mapActions('frecuenciaRespetoPrincipio', ['fetchFrecuenciaRespetoPrincipio']),
    ...mapActions('periodicidad', ['fetchPeriodicidad']),
    ...mapActions('resultado', ['fetchResultados']),
    ...mapActions('productividad', ['fetchProductividad']),
    ...mapActions('funcion', ['fetchFunciones']),
    ...mapActions('indicador', ['fetchIndicadores']),
    ...mapActions('frecuenciaProductividad', ['fetchFrecuenciaProductividad']),
    ...mapActions('actoRelevante', ['fetchActosRelevantes']),
    ...mapActions('municipio', ['fetchMunicipios']),
    ...mapActions('convocatorias', ['fetchAllConvocatorias']),
    ...mapActions('tipoConvocatoria', ['fetchTipoConvocatoria']),
    ...mapActions('promociones', ['fetchPromociones']),
    ...mapActions('condecoraciones', ['fetchCondecoraciones']),
    ...mapActions('procedimiento', ['fetchProcedimiento']),
    ...mapActions('estadoCivil', ['fetchEstadoCivil']),
    ...mapActions('tipoNacionalidad', ['fetchTipoNacionalidad']),
    ...mapActions('sexo', ['fetchSexo']),
    ...mapActions('grupoSanguineo', ['fetchGrupoSanguineo']),
    ...mapActions('estado', ['fetchEstados']),

    ...mapMutations(['DISABLE_LOADER', 'ENABLE_LOADER']),
  },
}
</script>
